import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from "../../contexts/user.context";
import {
    updateAcceptedChallenge,
    deleteAcceptedChallenge
} from "../../utils/firebase/firebase.utils";
import ProgressBar from '../progressBar/progressBar.comp';
import "./acceptedChallengeDetails.style.scss"
import AcceptedChallengeEvent from '../acceptedChallengeEvent/acceptedChallengeEvent.comp';
import Button from '../button/button.comp';
import OptionsADC from '../optionsACD/optionsACD.comp';
import { useChallenge } from '../../contexts/challenges.context';
import { initialAcceptedChallenges } from '../../utils/initialObjects.comp'

const AcceptedChallengeDetails = () => {

    // Nav, Contexts & Params
    const { userID } = useContext(UserContext);
    const { uniqueId } = useParams();
    const { selectedChallenge } = useChallenge();

    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/currentchallenges');
    };


    // Loading Challenges

    const [acceptedChallenge, setAcceptedChallenge] = useState(initialAcceptedChallenges[0]);
    const [anchor, setAnchor] = useState();
    const [challengeLoadedBoolean, setChallengeLoadedBoolean] = useState(false);
    useEffect(() => {
        if (selectedChallenge) {
            const timer = setTimeout(async () => {
                setAcceptedChallenge(selectedChallenge);
                setAnchor(JSON.parse(JSON.stringify(selectedChallenge)));
                setChallengeLoadedBoolean(true);
            }, 200);

            return () => clearTimeout(timer);
        } else {
            navigate('/'); // Redirect to home if no challenge is selected
        }
    }, [selectedChallenge]);


    //Finding Totals
    const [total, setTotal] = useState(0);
    const [trueCount, setTrueCount] = useState(0);
    const [percentageCompletion, setPercentageCompletion] = useState(0);
    useEffect(() => {
        if (acceptedChallenge) {
            const eventsTotal = acceptedChallenge.eventsTotal || 0;
            const completedEvents = acceptedChallenge.events
                .filter((_, index) => index % 5 === 4) // Only consider boolean values
                .filter((event) => event === true).length;
            const completionPercentage = eventsTotal ? (completedEvents / eventsTotal) * 100 : 0;

            setTotal(eventsTotal);
            setTrueCount(completedEvents);
            setPercentageCompletion(completionPercentage);
        }
    }, [acceptedChallenge]);


    //Test Printing
    const printChallenges = () => {
        console.log('Accepted Challenge: ', acceptedChallenge)
        console.log('Anchor: ', anchor)
    }


    //Saving to Firebase & Saving Pop Up
    const [changesFlag, setChangesFlag] = useState(false)
    const [savePopUp, setSavePopUp] = useState(false)
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const handleSave = () => {
        setSavePopUp(true)
    };
    const handleCancel = () => {
        setChangesFlag(false)
        setAcceptedChallenge(anchor)
    };
    const handleSaveToFirebase = async () => {
        try {
            setSaving(true)
            await updateAcceptedChallenge(acceptedChallenge.id, acceptedChallenge);
            console.log('All challenges updated successfully.');
        } catch (error) {
            console.error('Error updating challenges:', error);
        }

        setSaving(false)
        setChangesFlag(false)
        setSaved(true)
        setAnchor(JSON.parse(JSON.stringify(acceptedChallenge))); // Deep copy of loadedChallenges
    }
    const handleCloseSavePopUp = () => {
        setSavePopUp(false)
    }
    const handleClosePopUp = () => {
        setSavePopUp(false)
        setChangesFlag(false)
        setSaving(false)
        setSaved(false)
    }


    //Marking Done
    const toggleDone = (booleanIndex) => {
        setAcceptedChallenge((prevChallenge) => {
            // Create a copy of the current challenge
            const updatedChallenge = { ...prevChallenge };

            // Create a copy of the events array
            const updatedEvents = [...updatedChallenge.events];

            // Toggle the boolean value at the specified index
            updatedEvents[booleanIndex] = !updatedEvents[booleanIndex];

            // Update the events in the challenge
            updatedChallenge.events = updatedEvents;

            console.log(
                "Updated Challenge: ", updatedChallenge,
                "Updated Events Array: ", updatedEvents,
                "Boolean Index: ", booleanIndex,
                "Event before toggle: ", prevChallenge.events[booleanIndex],
                "Event after toggle: ", updatedEvents[booleanIndex]
            );

            // Return the updated challenge
            return updatedChallenge;
        });

        setChangesFlag(true);
    };


    //Dating
    function getDayIndex(dateString) {
        // Create a new Date object from the date string
        const date = new Date(dateString);

        // Get the day of the week (0 is Sunday, 6 is Saturday)
        const dayOfWeek = date.getDay();

        // Map Sunday (0) to 6 and adjust other days accordingly
        const dayIndexMap = [6, 0, 1, 2, 3, 4, 5];

        // Return the corresponding index
        return dayIndexMap[dayOfWeek];
    }
    function getNewDate(dateString, difference) {
        // Create a new Date object from the date string
        const date = new Date(dateString);

        // Adjust the date by adding the difference (in days)
        date.setDate(date.getDate() + difference);

        // Format the new date to 'YYYY-MM-DD'
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');

        // Return the new date string
        return `${year}-${month}-${day}`;
    }
    const handleDayClick = (buttonIndex, dateIndex, boolean, date) => {

        if (boolean === false) {

            const nowButtonIndex = getDayIndex(date)
            const difference = buttonIndex - nowButtonIndex;
            const newDate = getNewDate(date, difference);

            console.log(
                "Button Index: ", buttonIndex,
                "Now Button Index: ", nowButtonIndex,
                "Difference: ", difference,
                "Date Index: ", dateIndex,
                "Boolean: ", boolean,
                "Date: ", date,
                "New Date: ", newDate
            )

            // Create a deep copy of the specific challenge to avoid mutating the state directly
            const thisChallenge = { ...acceptedChallenge };
            thisChallenge.events = [...thisChallenge.events];
            thisChallenge.events[dateIndex] = newDate;

            setAcceptedChallenge(thisChallenge)
            setChangesFlag(true)
        }
    }


    //Date Formating
    const formatDateTwo = (dateString) => {
        const date = new Date(dateString);
        const options = { month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-US', options);
    };
    const formatDate = (date) => {
        // const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const options = { month: 'short', day: 'numeric' };
        return new Date(date).toLocaleDateString(undefined, options);
    };
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const getDayOfWeek = (date) => {
        return days[new Date(date).getDay()];
    };


    //OptionsPopUp
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const popupRef = useRef(null);
    const handleOptionsClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        const popupWidth = 200; // Adjust this to your popup width
        setPopupPosition({ x: rect.right - popupWidth, y: rect.bottom });
        setShowPopup(true);
    };
    const handlePopupClose = () => {
        setShowPopup(false);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);


    //Options: Go To Challenge
    const handleGoToChallenge = () => {
        navigate(`/challenge/${acceptedChallenge.challengeID}`);
    }

    //Options: View Challenge Detials
    const [showDetails, setShowDetails] = useState(false);
    const handleViewDetails = () => {
        console.log("deleting challenge")
        setShowDetails(true)
    }
    const handleCloseDetials = () => {
        setShowDetails(false)
    }


    //Options: Delete Challenge
    const [deleteChallenge, setDeleteChallenge] = useState(false);
    const [deleting, setDeleting] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const handleDelete = () => {
        console.log("deleting challenge")
        setDeleteChallenge(true)
    }
    const handleDeleteInFirebase = async () => {
        try {
            setDeleting(true)
            await deleteAcceptedChallenge(acceptedChallenge.id);
            console.log('All challenges updated successfully.');
        } catch (error) {
            console.error('Error updating challenges:', error);
        }

        setDeleting(false)
        setChangesFlag(false)
        setDeleted(true)
    }
    const handleCloseDeleting = () => {
        setDeleteChallenge(false)
        if (deleted) {
            navigate('/currentchallenges');
        }
    }
    const handleNavToCurrentChallenges = () => {
        navigate('/currentchallenges')
    }


    return (
        <div>
            {/* Navigation Buttons */}
            <div className="section frame">
                <div className="navbar">
                    <h4 onClick={handleBack}>Back</h4>
                </div>
            </div>

            {/* Loading Circle */}
            {
                !challengeLoadedBoolean ? (
                    <div className="loading-circle"></div>
                ) : null
            }

            {/* Header Info */}
            {
                challengeLoadedBoolean ? (
                    <div className="section flex frame">
                        <div
                            className='accepted-challenge-image'
                            style={{
                                backgroundImage: `url(${acceptedChallenge.imageURL})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}
                        >
                        </div>
                        <div className='accepted-challenge-info'>
                            <ProgressBar percentageCompletion={percentageCompletion} />
                            <div className="ac-title">
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <h2>{acceptedChallenge.title}</h2>
                                    <p style={{ fontWeight: 'bold', color: 'var(--fontdarkgrey)' }}>{trueCount} / {total}</p>
                                </div>
                                <div className="options" onClick={handleOptionsClick}>
                                    ···
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Buttons & Tasks List */}
            {challengeLoadedBoolean && (
                <div className='section frame'>
                    <div className='scrollable-container'>

                        {/* Buttons */}
                        {
                            !changesFlag || savePopUp ? (
                                <div
                                    className="button-wrapper"
                                    style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}
                                >
                                    <Button text={'Cancel'} option={'inactive'} />
                                    <Button text={'Save'} option={'inactive'} />
                                </div>
                            ) : (
                                <div
                                    className="button-wrapper"
                                    style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}
                                >
                                    <Button text={'Cancel'} option={'button-linked-text'} onClick={handleCancel} />
                                    <Button text={'Save'} option={'green'} onClick={handleSave} />
                                </div>
                            )
                        }

                        {/* Events by Week */}
                        <div className='accepted-challenge-events'>
                            {
                                acceptedChallenge.events.map((row, index) => {

                                    if (index % 5 === 1 && row === 1) {

                                        const eventsArray = acceptedChallenge.events;

                                        const dateIndex = index + 2;
                                        const booleanIndex = index + 3;

                                        const eventNumber = eventsArray[index - 1];
                                        const date = eventsArray[index + 2]
                                        const boolean = eventsArray[index + 3];

                                        const eventsTotal = acceptedChallenge.eventsTotal;

                                        const dayOfWeek = getDayOfWeek(date);
                                        const IndexOfDay = days.indexOf(dayOfWeek);

                                        const dayString = getDayOfWeek(date)
                                        const dateString = formatDate(date);

                                        return (
                                            <AcceptedChallengeEvent
                                                eventNumber={eventNumber}
                                                eventsTotal={eventsTotal}
                                                eventTime={acceptedChallenge.eventTime}
                                                eventTitle={acceptedChallenge.eventTitle}
                                                handleDayClick={handleDayClick}
                                                boolean={boolean}
                                                booleanIndex={booleanIndex}
                                                indexOfDay={IndexOfDay}
                                                dateIndex={dateIndex}
                                                dayString={dayString}
                                                dateString={dateString}
                                                toggleDone={toggleDone}
                                                date={date}
                                            />
                                        )
                                    }
                                })
                            }
                        </div>
                        <div className='accepted-challenge-events'>
                            {
                                acceptedChallenge.events.map((row, index) => {

                                    if (index % 5 === 1 && row === 2) {
                                        const eventsArray = acceptedChallenge.events;

                                        const dateIndex = index + 2;
                                        const booleanIndex = index + 3;

                                        const eventNumber = eventsArray[index - 1];
                                        const date = eventsArray[index + 2]
                                        const boolean = eventsArray[index + 3];

                                        const eventsTotal = acceptedChallenge.eventsTotal;

                                        const dayOfWeek = getDayOfWeek(date);
                                        const IndexOfDay = days.indexOf(dayOfWeek);

                                        const title = acceptedChallenge.title;

                                        const dayString = getDayOfWeek(date)
                                        const dateString = formatDate(date);

                                        return (
                                            <AcceptedChallengeEvent
                                                eventNumber={eventNumber}
                                                eventsTotal={eventsTotal}
                                                eventTime={acceptedChallenge.eventTime}
                                                eventTitle={acceptedChallenge.eventTitle}
                                                handleDayClick={handleDayClick}
                                                boolean={boolean}
                                                booleanIndex={booleanIndex}
                                                indexOfDay={IndexOfDay}
                                                dateIndex={dateIndex}
                                                dayString={dayString}
                                                dateString={dateString}
                                                toggleDone={toggleDone}
                                                date={date}
                                            />
                                        )
                                    }
                                })
                            }
                        </div>
                        <div className='accepted-challenge-events'>
                            {
                                acceptedChallenge.events.map((row, index) => {

                                    if (index % 5 === 1 && row === 3) {
                                        const eventsArray = acceptedChallenge.events;

                                        const dateIndex = index + 2;
                                        const booleanIndex = index + 3;

                                        const eventNumber = eventsArray[index - 1];
                                        const date = eventsArray[index + 2]
                                        const boolean = eventsArray[index + 3];

                                        const eventsTotal = acceptedChallenge.eventsTotal;

                                        const dayOfWeek = getDayOfWeek(date);
                                        const IndexOfDay = days.indexOf(dayOfWeek);

                                        const title = acceptedChallenge.title;

                                        const dayString = getDayOfWeek(date)
                                        const dateString = formatDate(date);

                                        return (
                                            <AcceptedChallengeEvent
                                                eventNumber={eventNumber}
                                                eventsTotal={eventsTotal}
                                                eventTime={acceptedChallenge.eventTime}
                                                eventTitle={acceptedChallenge.eventTitle}
                                                handleDayClick={handleDayClick}
                                                boolean={boolean}
                                                booleanIndex={booleanIndex}
                                                indexOfDay={IndexOfDay}
                                                dateIndex={dateIndex}
                                                dayString={dayString}
                                                dateString={dateString}
                                                toggleDone={toggleDone}
                                                date={date}
                                            />
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            )}

            {/* Options Pop Up */}
            {showPopup && <OptionsADC
                ref={popupRef}
                position={popupPosition}
                onClose={handlePopupClose}
                onGoToChallenge={handleGoToChallenge}
                onViewDetails={handleViewDetails}
                onDelete={handleDelete}
            />}

            {/* Pop Up: Save Changes */}
            {savePopUp && (
                <div className="save-pop-up-container">
                    <div className="save-pop-up">
                        <div className="save-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseSavePopUp}>
                                </div>
                            </div>
                        </div>
                        {
                            saving ? (
                                <div className="save-pop-up-scroll-view ">
                                    <p style={{ width: '100%', textAlign: 'center' }}>Saving...</p>
                                    <div className="this-week-loading-circle"></div>
                                </div>
                            ) : (
                                saved ? (
                                    <div className="save-pop-up-scroll-view ">
                                        <p style={{ width: '100%', textAlign: 'center' }}>Your changes are saved!</p>
                                        <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ width: '100%', textAlign: 'center' }}>Are you sure you want to save changes?</p>
                                        <Button text={'Save'} option={'green'} onClick={handleSaveToFirebase} />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            )}

            {/* Pop Up: Show Details */}
            {showDetails && (
                <div className="save-pop-up-container">
                    <div className="save-pop-up">
                        <div className="save-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseDetials}>
                                </div>
                            </div>
                        </div>
                        <div className="save-pop-up-scroll-view ">
                            <p><strong>{acceptedChallenge.info}</strong></p>
                            <p>{acceptedChallenge.subtitle}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Pop Up: Quite Challenge */}
            {deleteChallenge && (
                <div className="save-pop-up-container">
                    <div className="save-pop-up">
                        <div className="save-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseDeleting}>
                                </div>
                            </div>
                        </div>
                        {
                            deleting ? (
                                <div className="save-pop-up-scroll-view ">
                                    <p style={{ width: '100%', textAlign: 'center' }}>Quiting challenge...</p>
                                    <div className="this-week-loading-circle"></div>
                                </div>
                            ) : (
                                deleted ? (
                                    <div>
                                        <p style={{ width: '100%', textAlign: 'center' }}>Done</p>
                                        <Button text={'Close'} option={'yellow'} onClick={handleNavToCurrentChallenges} />
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ width: '100%', textAlign: 'center' }}>Are you sure you want to <strong>quit</strong> this challenge? All your progress will be lost.</p>
                                        <Button text={'Quit'} option={'red'} onClick={handleDeleteInFirebase} />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            )}

            {/* <div className="footer-margin"></div> */}
        </div>
    );
};

export default AcceptedChallengeDetails;